import { installPoptipToApp, loadPoptip } from "@visactor/vrender-components/poptip";

import { Factory } from "../../core/factory";

const installPoptip = app => {
    app ? installPoptipToApp(app) : loadPoptip();
};

export const registerPoptip = () => {
    Factory.registerRuntimePluginInstaller("poptipForText", installPoptip), installPoptip();
};
//# sourceMappingURL=index.js.map
